import { render, staticRenderFns } from "./AwardGroupEditorPage.vue?vue&type=template&id=0cb278e8&scoped=true&"
import script from "./AwardGroupEditorPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardGroupEditorPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardGroupEditorPage.vue?vue&type=style&index=0&id=0cb278e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb278e8",
  null
  
)

export default component.exports